import { render, staticRenderFns } from "./collectionNew.vue?vue&type=template&id=407a93cd&scoped=true"
import script from "./collectionNew.vue?vue&type=script&lang=js"
export * from "./collectionNew.vue?vue&type=script&lang=js"
import style0 from "./collectionNew.vue?vue&type=style&index=0&id=407a93cd&scoped=true&lang=css"
import style1 from "./collectionNew.vue?vue&type=style&index=1&id=407a93cd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407a93cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('407a93cd')) {
      api.createRecord('407a93cd', component.options)
    } else {
      api.reload('407a93cd', component.options)
    }
    module.hot.accept("./collectionNew.vue?vue&type=template&id=407a93cd&scoped=true", function () {
      api.rerender('407a93cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/leftMoudle/dialog/collectionNew.vue"
export default component.exports